module.exports = __webpack_public_path__ + "static/img/r4-name.bb16f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/mobile/role/r4-name.png
// module id = lI/R
// module chunks = 0